import React from 'react';

const Questions = () => {
    return (
        <div className="ch-quiz-questions">
            <span>Yue's Questions</span>
        </div>
    );
};

export default Questions;